import { FC } from 'react';
import { NodeProps } from 'react-flow-renderer';
import { ReactFlowApprovalTaskNode } from 'features/workflow/types/react-flow.types';
import TaskNode from '../Task/TaskNode';

const ApprovalNode: FC<NodeProps<ReactFlowApprovalTaskNode['data']>> = (props) => <TaskNode {...props} />;

export default ApprovalNode;
